// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:12:09

export default {
  "id": "woop-crawl-up",
  "slug": "woop-crawl-up",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/98a40642dac54d7b9ab0c03f3f785e6f-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/98a40642dac54d7b9ab0c03f3f785e6f/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Woop Crawl Up",
      "description": "Woop Crawl Up – A Tricky Worm Puzzle Adventure!\n\nHelp the little worm crawl its way home! Use solid earth blocks to support its movement, but be careful—if you move into an area without support, you’ll fall and lose! Plan your path wisely and test your puzzle-solving skills in this challenging yet fun adventure!",
      "instructions": "✔️Move the worm carefully through the level \n✔️ Use hard earth blocks for support \n✔️ Avoid unsupported areas or you'll lose!\n✔️ Reach home safely to complete the level!",
      "genres": [
        "Puzzle",
        "Casual"
      ],
      "tags": [
        "1player",
        "worm"
      ]
    },
    "zh-CN": {
      "title": "呜普爬升",
      "description": "Woop爬行挑战——一个棘手的虫子解谜冒险！\n\n帮助这个小虫子爬回家！使用坚固的土块来支撑它的移动，但要注意——如果你进入了一个没有支撑的区域，你就会掉下去并失败！明智地规划你的路线，在这场既具挑战性又有趣的冒险中测试你的解谜技巧！",
      "instructions": "✔️小心地将虫子移动通过关卡\n✔️使用硬土块作为支撑\n✔️避免无支撑区域，否则会失败！\n✔️安全到达家完成关卡！",
      "genres": [
        "拼图",
        "休闲"
      ],
      "tags": [
        "1玩家",
        "蠕虫"
      ]
    },
    "zh-TW": {
      "title": "烏普爬升",
      "description": "Woop Crawl Up – 一個挑戰性高又有趣的蚯蚓拼圖冒險！\n\n幫助這條小蚯蚓爬回家！使用實心土地塊來支撐其移動，但請小心——如果你進入沒有支撐的地區，你會墜落並失去遊戲！謹慎規劃你的路徑，並在這個挑戰性但有趣的冒險中檢驗你的解謎技巧！",
      "instructions": "✔️小心移動蠕蟲通過關卡\n✔️使用堅硬的土塊作為支撐\n✔️避免沒有支撐的區域，否則你會輸！\n✔️安全抵達家園完成關卡！",
      "genres": [
        "謎題",
        "休闲"
      ],
      "tags": [
        "1 玩家",
        "蠕蟲"
      ]
    },
    "zh-HK": {
      "title": "咩咩爬升",
      "description": "Woop Crawl Up – 一個難關重重的蚯蚓拼圖冒險！\n\n幫助這條小蚯蚓爬回家！使用堅固的土塊來支撐它的移動，但請小心——如果你進入沒有支撐的區域，你會掉下去並失敗！精心規劃你的路徑，在這個既挑戰又有趣的冒險中挑戰你的解謎技巧！",
      "instructions": "✔️小心將蚴動過關卡\n✔️使用堅硬的土塊作為支撐\n✔️避免沒有支撐的區域，否則會失敗！\n✔️安全抵達家園以完成關卡！",
      "genres": [
        "謎題",
        "休閒遊戲"
      ],
      "tags": [
        "1玩家",
        "蚯蚓"
      ]
    },
    "ja": {
      "title": "ウーップク raw up",
      "description": "Woop Crawl Up – 恥ずかしいワームパズルアドベンチャー！\n\n小さなワームが家に戻る手助けをしよう！固体の地球ブロックを使って動きをサポートするが、サポートのない場所に移動すると落ちて失敗するので注意しよう！賢く道筋を計画し、この挑戦的で楽しいアドベンチャーでパズル解決スキルを試してみよう！",
      "instructions": "✔️レベルを慎重にワームを通過させる\n✔️硬い土のブロックを使用して支えよう\n✔️不支のエリアを避けないとゲームオーバーになるぞ！\n✔️安全に家に到着してレベルをクリアしよう！",
      "genres": [
        "パズル",
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "ワーム"
      ]
    },
    "ko": {
      "title": "우옹 크롤 아پ",
      "description": "Woop Crawl Up – 난쟁이 earth blocks를 사용하여 집으로 올라가는 미로 탐험!\n\n작은 미미를 집으로 돌아가게 도와주세요! 단단한 earth blocks를 이용하여 움직임을 지원하세요, 하지만 주의하세요 – 지원 없는 지역으로 이동하면 추락하고 게임이 끝납니다! 이 어려운yet 재미있는 탐험에서 여유롭게 경로를 계획하고 퍼즐 해결 능력을 테스트하세요!",
      "instructions": "✔️ 뱀을 주의 깊게 레벨을 통해 이동하세요\n✔️ 지지대로 사용할 고верд 블록을 사용하세요\n✔️ 지지되지 않은 구역을 피하십시오, 그렇지 않으면 패배합니다!\n✔️ 안전하게 집에 도착하여 레벨을 완료하세요!",
      "genres": [
        "퍼즐",
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "원虫"
      ]
    },
    "fr": {
      "title": "Woop Pousser Vers Le Haut",
      "description": "Woop Crawl Up – Une Aventure de Labyrinthe de Ver Intriguant !\n\nAidez le petit ver à trouver son chemin vers la maison ! Utilisez des blocs de terre solides pour soutenir son déplacement, mais soyez prudent – si vous entrez dans une zone sans soutien, vous tombez et perdez ! Planifiez votre itinéraire avec sagesse et mettez vos compétences de résolution de puzzles à l'épreuve dans cette aventure challengeante mais amusante !",
      "instructions": "✔️Déplacez délicatement le ver à travers le niveau\n✔️Utilisez des blocs de terre durs pour le soutien\n✔️Évitez les zones non soutenues ou vous perdrez !\n✔️Arrivez chez vous en toute sécurité pour terminer le niveau !",
      "genres": [
        "Puzzle",
        "Loisir"
      ],
      "tags": [
        "1 joueur",
        "ver"
      ]
    }
  }
};
